import { forwardRef, type HTMLAttributes } from 'react';
import GoodsTileIcon from '@assets/img/dice-game/goods.svg?react';
import cn from 'classnames';

import { Tile } from '../Tile/Tile';
import { TilesBg } from '../TilesBg/TilesBg';

interface GoodsTileProps extends HTMLAttributes<HTMLDivElement> {
  isActive?: boolean;
}

const GoodsTile = forwardRef<HTMLDivElement, GoodsTileProps>((props, ref) => {
  return (
    <Tile
      ref={ref}
      {...props}
      variant={props.isActive ? 'dark' : 'grey'}
      className={cn(props.className, 'flex items-center justify-center')}
    >
      <GoodsTileIcon className="size-[90%] relative z-[3]" />
      {props.isActive && <TilesBg variant="green-active" />}
    </Tile>
  );
});

export { GoodsTile };
